import { useCallback, useState } from "react";

import {
	type ApplicationsRefreshMs,
	persistApplicationsRefreshMs,
	readApplicationsRefreshMs,
} from "@/features/applications/lib/applications-refresh";

export function useApplicationsRefresh() {
	const [refreshMs, setRefreshMsState] = useState(readApplicationsRefreshMs);

	const setRefreshMs = useCallback((next: ApplicationsRefreshMs) => {
		setRefreshMsState(next);
		persistApplicationsRefreshMs(next);
	}, []);

	return { refreshMs, setRefreshMs };
}
